import { useEffect } from 'react'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import { CarListing, HotelListing } from './types'

const useCrossSellAnalytics = (listings: CarListing[] | HotelListing[]) => {
  useEffect(() => {
    analytics.fireEvent({
      action: 'xsell load',
      category: ANALYTICS_CATEGORY_HOME,
      label: 'xsell display'
    })
  }, [])

  useEffect(() => {
    if (listings.length > 1) {
      analytics.fireEvent({
        action: 'upcoming trip',
        category: ANALYTICS_CATEGORY_HOME,
        label: 'xsell inventory display'
      })
    }
  }, [listings.length])
}

export default useCrossSellAnalytics
